import React, { useEffect } from 'react'
import "../css/events.css"
import { Breadcrumb, Button, Card, Col, Container, Row } from 'react-bootstrap'
import { assets } from '../assets/assets'
import { Lawndata } from '../data/lawnData'
import { useNavigate } from 'react-router-dom'
import Aos from 'aos'
import "aos/dist/aos.css";

export const Events = () => {

    const navigate = useNavigate()

       useEffect(() => {
            Aos.init({ duration: 1000 })
        })

    return (
        <>
            <Container
                fluid
                className="gallery-header d-flex justify-content-start align-items-center"
            >
                <Row>
                    <Col data-aos="fade-up" data-aos-delay="100">
                        <h1 className="gallery-title">Lawn/Hall</h1>
                    </Col>
                </Row>
            </Container>


            <Container fluid style={{
                padding: "2rem"
            }}>
                <Row>
                    <Col md={12} style={{
                    }}>

                        <Row>

                            {Lawndata.map((data) => (

                                <Col md={6} key={data.id} className='lawn-main-grid'>

                                    <Card
                                            data-aos="fade-up" data-aos-delay="100"
                                        onClick={() => navigate(`/lawn/${data.id}`)}
                                        className='lawndata-card'>

                                        <div style={{
                                            display: "flex",
                                            justifyContent: "space-around",
                                            alignItems: "center",
                                            flexDirection: "row",
                                        }}>
                                            <p className='lawn-name'>{data.name}</p>

                                            <Button
                                                // onClick={() => navigate(`/lawn/${data.id}`)}
                                                className='event-lawn-btn'>+</Button>
                                        </div>

                                        <div style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            flexDirection: "column",
                                            marginTop: "1rem",
                                            overflow: "hidden"
                                        }}>
                                            <p className='evet-lawn-address'>{data.address} </p>

                                            <img className='event-lawn-img' src={data.img} alt="food" />
                                        </div>
                                    </Card>
                                </Col>
                            ))}

                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
